// What a keyless install exports today — rendered from `keylessExportRows` in @/lib/limits,
// the dashboard's ONE source for these values (never typed into markup: ui/DESIGN.md §9,
// DECISIONS D40 (2)). Those rows mirror web/src/lib/features.ts row for row, so the labels
// and wording are identical in the dashboard and on the marketing pages.
// Shown on /buy and on the keyless /license state. Stated as facts, never as an upsell.

import { DescriptionDetails, DescriptionList, DescriptionTerm } from "@/ui";
import { keylessExportRows } from "@/lib/limits";

export function KeylessExportLimits({ className }: { className?: string }) {
  return (
    <DescriptionList className={className}>
      {keylessExportRows.map((row) => (
        <div key={row.term} className="contents">
          <DescriptionTerm>{row.term}</DescriptionTerm>
          <DescriptionDetails>{row.value}</DescriptionDetails>
        </div>
      ))}
    </DescriptionList>
  );
}
